import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsTheAncientDocumentExceptionForANyWillPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/the-ancient-document-exception-for-a-ny-will/']} />;
}
